var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "col-12" },
    [
      _c("div", { staticClass: "card" }, [
        _c("ul", { staticClass: "list-group list-group-flush" }, [
          _c("li", { staticClass: "list-group-item" }, [
            _c("h6", { staticClass: "grey-text text-darken-3 m-0" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("settings.accountTab.profilePicture")) +
                  "\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "list-group-item" }, [
            _c(
              "div",
              {
                staticClass: "settings-container mx-0 col-lg-10",
                attrs: { id: "profile-picture-container" },
              },
              [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-md-4 px-3 col-12 d-flex flex-row justify-content-center d-md-block",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "image-cropper-xlg" },
                        [
                          _c(
                            "profile-avatar",
                            _vm._b(
                              { staticClass: "profilepic img-fluid" },
                              "profile-avatar",
                              Object.assign({}, _vm.userDetails),
                              false
                            )
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-8 col-md-8 mt-sm-0 mt-4" }, [
                    _c(
                      "p",
                      { staticClass: "justified grey-text text-darken-1" },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.$t(
                                "settings.accountTab.profilePictureDescription"
                              )
                            ) +
                            "\n              "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-xl-4 mb-xl-0 mb-2" }, [
                        _c(
                          "a",
                          {
                            staticClass:
                              "clickable mb-0 w-100 btn btn-sm b-settings btn-moregage btn-primary",
                            attrs: { id: "upload-profile" },
                            on: {
                              click: function ($event) {
                                return _vm.$refs.file.click()
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$t("global.actions.uploadPhoto")) +
                                "\n                  "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          ref: "file",
                          staticStyle: { display: "none" },
                          attrs: {
                            id: "selected-profile-image",
                            type: "file",
                            accept: "image/x-png,image/gif,image/jpeg",
                          },
                          on: { change: _vm.handleFileUpload },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            attrs: {
                              for: "selected-profile-image",
                              hidden: "",
                            },
                          },
                          [_vm._v("Profile Image")]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-xl-6" }, [
                        _c(
                          "a",
                          {
                            staticClass:
                              "w-100 btn clickable b-settings btn-sm btn-white mb-0",
                            attrs: { id: "remove-profile" },
                            on: { click: _vm.handleRemovePhoto },
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$t("global.words.remove")) +
                                "\n                    "
                            ),
                            _c(
                              "span",
                              { staticClass: "d-md-none d-lg-inline" },
                              [
                                _vm._v(
                                  "\n                      " +
                                    _vm._s(
                                      _vm.$t("settings.accountTab.currentPhoto")
                                    ) +
                                    "\n                    "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm.openPhotoCropper
        ? _c("picture-cropper", {
            ref: "pictureCropperModal",
            attrs: { file: _vm.file },
            on: {
              cropped: _vm.handlePictureCropped,
              hidden: _vm.clearFileSelect,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }